<template>
  <ButtonDefault
    color="blue"
    :disabled="!puedeConsultar || consultando"
    :is-loading="consultando"
    @click="consultarListaSql"
  >
    <component :is="icono" class="size-4 shrink-0" />
    Consultar {{ comp.label }}
  </ButtonDefault>
  <p
    v-if="!puedeConsultar"
    class="mt-1 text-xs text-gray-500 dark:text-gray-400"
  >
    {{ mensajeNoDisponible }}
  </p>
  <ListaSqlModal
    ref="modalRef"
    :modal-id="`lista-sql-${comp.name}`"
    :tipo-grafica="tipoGrafica"
  />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import {
  ChartBarIcon,
  ChartPieIcon,
  MagnifyingGlassIcon
} from '@heroicons/vue/24/outline'
import type { IFormComponent } from '@/modules/Configuracion/interfaces/IFormComponent'
import type { TipoGraficaListaSql } from '@/modules/Configuracion/interfaces'
import { useListaSql } from '@/modules/Configuracion/composables/useListaSql'
import { obtenerTituloFallbackListaSql } from '@/modules/Configuracion/utils/listaSql'
import ListaSqlModal from '@/modules/Core/components/ListaSql/ListaSqlModal.vue'

const props = defineProps<{
  comp: IFormComponent
  tipoGrafica?: TipoGraficaListaSql
  cittId?: number
  editable?: boolean
}>()

const modalRef = ref<InstanceType<typeof ListaSqlModal> | null>(null)
const { consultando, error, cargarResultadoTabla, cargarResultadoGrafica } = useListaSql()

const puedeConsultar = computed(() => {
  return !props.editable && !!props.cittId && !!props.comp.properties?.coreId
})
const icono = computed(() => {
  if (props.tipoGrafica === 'bar') return ChartBarIcon
  if (props.tipoGrafica === 'doughnut') return ChartPieIcon
  return MagnifyingGlassIcon
})
const mensajeNoDisponible = computed(() => {
  if (!props.comp.properties?.coreId) return 'Debe configurar un reporte para realizar la consulta.'
  return 'Disponible únicamente dentro de una atención.'
})

const consultarListaSql = async () => {
  const coreId = props.comp.properties?.coreId
  if (!puedeConsultar.value || !coreId || !props.cittId || !modalRef.value) return

  window.notificacion.loading().circle('Consultando información...')
  try {
    const parametros = {
      coreId,
      cittId: props.cittId,
      label: obtenerTituloFallbackListaSql(props.comp)
    }
    const resultado = props.tipoGrafica
      ? await cargarResultadoGrafica(parametros, props.tipoGrafica)
      : await cargarResultadoTabla(parametros)
    await modalRef.value.open(resultado)
  } catch (errorConsulta) {
    console.error('Error consultando el reporte del componente:', errorConsulta)
    window.notificacion.notificacion(
      'failure',
      error.value || 'No fue posible consultar la información. Intenta nuevamente.'
    )
  } finally {
    window.notificacion.loading().remove()
  }
}
</script>
